import React from 'react'

import { SessionNotesV2 } from './session-notes-v2'

export function SessionNotes() {
  return <SessionNotesV2 />
}
